<template>
    <el-main class="view_detail" v-loading="emLoading">
        <retrieval-detail :DetailId="DetailId" v-if="isEffective"></retrieval-detail>
        <div class="noAuthority" v-else>{{errorMsg}}</div>
    </el-main>
</template>

<script>
    import {setLocal} from "../config/mUtils";
    import {GetEMTransAuth} from "../api/apiEMJump";
    import retrievalDetail from "./retrievalDetail";

    export default {
        name: 'emViewDetail',
        components: {retrievalDetail},
        data() {
            return {
                emLoading: true,
                isEffective: false,
                DetailId: '',
                errorMsg: ''
            };
        },
        computed: {},
        watch: {},
        created() {
            this.getEMTransAuth();
        },
        mounted() {
        },
        methods: {
            // EM系统跳转鉴权
            async getEMTransAuth() {
                this.DetailId = '';
                this.emLoading = true;
                try {
                    let data = await GetEMTransAuth(
                        this.$route.query.InvoiceKey
                    );
                    if (data.error_code === '0') {
                        this.emLoading = false;
                        this.isEffective = true;
                        this.DetailId = data.data;
                        if (this.$route.query.Language == 'zh-CN') {
                            setLocal('language', 'zh-CN');
                        } else if (this.$route.query.Language == 'en-GB') {
                            setLocal('language', 'en-US');
                        } else {
                            setLocal('language', 'zh-CN');
                        }
                    } else {
                        this.emLoading = false;
                        this.isEffective = false;
                    }
                } catch (error) {
                    console.log(error);
                }
            },
        }
    };
</script>

<style lang="less">
</style>
